import api from "./api";

export const registerUser = (payload) => api.post("/auth/register/", payload);
export const lookupReferralSponsor = (q, config = {}) =>
  api.get("/auth/referral-lookup/", { ...config, params: { q } });
export const verifyEmail = (payload) => api.post("/auth/verify-email/", payload);
export const resendEmailOtp = (payload) => api.post("/auth/resend-email-otp/", payload);
export const loginUser = (payload) => api.post("/auth/login/", payload);
export const requestPasswordReset = (payload) => api.post("/auth/password/reset/", payload);
export const confirmPasswordReset = (payload) => api.post("/auth/password/reset/confirm/", payload);
export const fetchMe = () => api.get("/users/me/");
export const fetchAdminMyModules = () => api.get("/users/admin/me/modules/");
export const updateMe = (payload) => api.patch("/users/me/", payload);
export const fetchKycStatus = () => api.get("/users/kyc/status/");
export const submitKyc = (payload) => api.post("/users/kyc/submit/", payload);
export const presignKycUpload = (payload) => api.post("/users/kyc/upload/presign/", payload);
